define(["require", "exports", "events/store"], function (require, exports, store_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.createContext = void 0;
    function createContext(request) {
        let masterEventStore = request.masterEventStore;
        if (!masterEventStore) {
            masterEventStore = new store_1.ScopedEventStore();
        }
        else if (request.newScope || request.parentContext == null) {
            masterEventStore = new store_1.ScopedEventStore();
        }
        else {
            masterEventStore = request.parentContext.$masterEventStore;
        }
        let koComponentInfo = null;
        if (isKnockoutComponentInfo(request.componentOrElement)) {
            koComponentInfo = request.componentOrElement;
        }
        let ci = {
            instanceId: request.instanceId,
            koComponentInfo: koComponentInfo || { element: request.componentOrElement, templateNodes: [] }
        };
        let componentEventStore = new store_1.ComponentEventStore(ci, masterEventStore);
        let contextData = {
            events: componentEventStore,
            componentInfo: ci,
            parentContext: request.parentContext,
            $masterEventStore: masterEventStore
        };
        return contextData;
    }
    exports.createContext = createContext;
    function isKnockoutComponentInfo(componentOrElement) {
        return typeof componentOrElement['element'] !== 'undefined';
    }
});
//# sourceMappingURL=ComponentContextFactory.js.map